import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { postcode } from "../../../shared/src/codecs/types/postcode";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { ListingReasonForSale1 } from "../ListingReasonForSale";

export const AddPartyListingForm: TFormCodec<
    TRequiredCodec<{
        party_id: ReturnType<typeof uuid>;
        building_name: ReturnType<typeof string>;
        building_number: ReturnType<typeof string>;
        street_name: ReturnType<typeof string>;
        city_town: ReturnType<typeof string>;
        postcode: ReturnType<typeof postcode>;
        reason_for_sale: typeof ListingReasonForSale1;
        admin_notes: ReturnType<typeof string>;
    }>,
    TEmptyObjectCodec
> = form(
    required({
        party_id: uuid(),
        building_name: string(),
        building_number: string(),
        street_name: string(),
        city_town: string(),
        postcode: postcode(),
        reason_for_sale: ListingReasonForSale1,
        admin_notes: string(),
    }),
    EmptyObject,
);

export type TAddPartyListingFormCodec = typeof AddPartyListingForm;
export type TAddPartyListingForm = TTypeOfCodec<TAddPartyListingFormCodec>;

export const AddPartyListingFields = required({
    building_name: string(),
    building_number: string(),
    street_name: string(),
    city_town: string(),
    postcode: string(),
    reason_for_sale: ListingReasonForSale1,
    admin_notes: string(),
});
export type TAddPartyListingFieldsCodec = typeof AddPartyListingFields;
